import styled from 'styled-components';

export default styled.section`
 

  @media (min-width: ${props => props.theme.breakpoints.desktop}) {
    padding: 0 ${props => props.theme.padding.inner} 7.4375rem;
  }

  > .inner {
    margin: auto;
    max-width: ${props => props.theme.maxWidths.containerSmall};

    @media (min-width: ${props => props.theme.breakpoints.desktop}) {
      max-width: ${props => props.theme.maxWidths.blurbsThree};
    }

    > header {
      text-align: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 2rem;

      .title {
          max-width: 250px;
          text-align: left;
        }

      .section-wrapper {
        display: grid;
        grid-template-columns: 50% 50%;
        align-items: center;
          

        @media (max-width: ${props => props.theme.breakpoints.desktopMed}) {
          grid-template-columns: 90%;
          padding: 0 0 1.5rem 1.5rem;
        }
      }

      .video-thumbnail {
        position: relative;
        cursor: pointer;
      }

      .thumbnail-wrapper{
        position: relative;
        
        img {
          width: 520px;
          box-shadow: 20px 20px ${props => props.theme.colors.blue10};
          @media (max-width: ${props => props.theme.breakpoints.desktopMed}) {
            width: 100%;
            height: auto;
          }
        }
      }

      .play-button {
        position: absolute;
        left: 63%;
        top: 50%;
        margin-top: -35.5px;

        @media (max-width: ${props => props.theme.breakpoints.desktopMed}) {
          left: 50%;
        }

        @media (max-width: ${props => props.theme.breakpoints.desktop}) {
          left: 43%;
        }

        @media (max-width: 470px) {
          left: 42%;
        }

        @media (max-width: 410px) {
          left: 38%;
        }
      }
    }
  }

 `;